module.exports = __webpack_public_path__ + "img/fuhe2.2e7697f0.svg";